import { Slider, DatePicker, Input } from 'formik-antd'
import { Formik, FieldArray } from 'formik'
import moment from 'moment'
import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../../model/rootReducer'
import { Container } from '../../../Styled'
import { StyledForm, CheckboxGroup, StyledCheckbox, Button } from '../../Styled'
import { updateEventFormList } from '../../../../../../helpers/monitoringGraphHelper'

const { RangePicker } = DatePicker

type FormProps = {
  generateGraph: (selectedFilters: Object) => void
}
const marks = {
  0: '0%',
  100: '100%',
}
const startDate = moment().add(-7, 'days')
const endDate = moment()
const GraphGenerationForm: React.FunctionComponent<FormProps> = ({
  generateGraph,
}) => {
  const events = useSelector((state: RootState) => state.monitoringGraph.events)
  const initialValues = {
    events: [],
    dateRange: [startDate, endDate],
    percentageRange: [1, 100],
  }
  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={(values) => {
        generateGraph(values)
      }}
      render={() => (
        <StyledForm>
          <Container>
            <RangePicker
              name="dateRange"
              ranges={{
                Today: [moment(), moment()],
                'This Month': [
                  moment().startOf('month'),
                  moment().endOf('month'),
                ],
              }}
            />
          </Container>
          <Slider
            name="percentageRange"
            range
            marks={marks}
            defaultValue={[1, 100]}
          />
          <FieldArray
            name="events"
            render={(arrayHelpers) => (
              <CheckboxGroup>
                {events.map((filter, index) => (
                  <div key={index}>
                    <StyledCheckbox
                      onClick={(event) =>
                        updateEventFormList(event, arrayHelpers, filter.name)
                      }
                      name={filter.name}
                    >
                      {filter.name}
                    </StyledCheckbox>
                  </div>
                ))}
              </CheckboxGroup>
            )}
          />
          <Button name="submit" loading={false}>
            Générer
          </Button>
        </StyledForm>
      )}
    />
  )
}

export default GraphGenerationForm
